import React, { useState, useEffect } from "react";
import AppForm from "./AppForm";
import { useParams } from "react-router-dom";
import { getApplication, updateApplication } from "../api/APIUtils";
import _ from "lodash";


const EditApp = ({ history , isAdmin, isOperator}) => {
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const { id } = useParams();
  useEffect(() => {
    async function fetchApp() {
      const response = await getApplication(id);
      console.log(response.data.getApplication);
      setApp(response.data.getApplication);
      setIsLoading(false);
    }
    fetchApp();
  }, [id]);
  const handleOnSubmit = (app) => {
    updateApplication(app)
      .then((response) => {
        console.log(response);
      })
      .catch((e) => {
        const err = _.get(e, "errors")
        const error = _.find(err, "message")
        console.log(error);
        alert(error.message);
      })
      .finally(() => {
        history.push("/");
      });
  };

  if (isLoading) return <div></div>;
  else
    return (
      <div>
        <AppForm app={app} handleOnSubmit={handleOnSubmit} edit={true} isAdmin={isAdmin} isOperator={isOperator}/>
      </div>
    );
};

export default EditApp;
